import { Box, Typography, Button } from "@mui/material";
import { TEST_JOURNEY_TUTORIAL_VIDEO_ID } from "constants/tutorialVideos";
import styles from "./styles.module.scss"

const EmptyJourneys = ({ handleAddJourney }) => {
    return (
        <Box className={styles.journeysEmpty}>
            <Typography className={styles.journeysEmptyLabel}>
                Start testing complex features
            </Typography>
            <Box className={styles.journeysVideoContainer}>
                <iframe
                    src={`https://www.youtube.com/embed/${TEST_JOURNEY_TUTORIAL_VIDEO_ID}`}
                    title="Test Journey tutorial video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
            </Box>
            <Typography className={styles.journeysEmptyText} variant='body2'>
                Record a Test Journey to show Treegress the happy path for the flow you want to test.
            </Typography>
            <Button className={styles.journeysEmptyAddButton} variant="contained" color="secondary" onClick={handleAddJourney}>
                Add Test Journey
            </Button>
        </Box>
    );
}

export default EmptyJourneys;
